<template>
<v-card>

  <v-breadcrumbs dense
    v-if="withCrumbs"
    :items="crumbs"
    class="py-0 grey lighten-4" />
  <v-divider/>

  <manage-toolbar
    :title="title"
    :business-id="businessId"
    :space.sync="space"
    :practitioner.sync="practitioner"
    :practitioner-id="initialPractitionerId"
    :practitioner-selectable="practitionerSelectable"
    @update:spaces="setSelectedSpaceById(initialSpaceId)" />

  <v-divider />

  <!-- <pre v-text="membership" class="caption pa-2 grey lighten-4" /> -->

  <!-- <v-alert text dense tile type="warning"
    v-if="!membershipId" >
    <strong>Note:</strong> This membership may be inactive. Reactive membership in order to edit details
  </v-alert> -->

  <v-tabs v-model='activeTab' v-if="spaceId && practitionerId && membershipId" >
    <v-tab >Permissions</v-tab>
    <v-tab >Operating hours</v-tab>
    <v-tab >Appointment Types</v-tab>

    <v-tabs-items v-model='activeTab' >
      <v-tab-item >
        <permission-picker
          v-if="membershipId"
          v-model="membership"
          :space-id="spaceId"
          :member-id="membershipId" />
      </v-tab-item>
      <v-tab-item >
        <template v-if="membershipId" >

          <template v-for="location in locations" >
            <member-location-hours class="ma-4"
              :key="location.id"
              :location="location"
              :practitioner="practitioner"
              :spaceId="spaceId" />
          </template>

        </template>
      </v-tab-item>
      <v-tab-item >
        <appointment-types-page
          v-if="membershipId"
          :space-id="spaceId"
          :member="practitioner" />
      </v-tab-item>
    </v-tabs-items>
  </v-tabs>

  <v-alert text tile
    v-if="spaceId && !membershipId"
    color="info"
    border="left" >
    <!-- <v-btn text small
      @click="addcolleaguedialog=true"
      class="float-right" >Add to {{spaceTitle}}</v-btn>
    {{practitioner.full_name}} is not a member of {{spaceTitle}} -->
  </v-alert>

  <v-dialog v-model="addcolleaguedialog" >
    <add-colleague @saved="addcolleaguedialog=false;init()" />
  </v-dialog>

  <!-- <v-row>
    <v-col cols="4" >
      Space: {{page}}: {{spaceId}} | {{initialSpaceId}}<br/>
      <pre v-text="space" class="caption grey lighten-4 pa-3" />
    </v-col>
    <v-col cols="4">
      Practitioiner:<br/>
      <pre v-text="practitioner" class="caption grey lighten-4 pa-3" />
    </v-col>
    <v-col cols="4">
      Membership:<br/>
      <pre v-text="membership" class="caption grey lighten-4 pa-3" />
    </v-col>
  </v-row> -->

</v-card>
</template>
<script>
import ManageToolbar from '@/components/layouts/ManageToolbar.vue'
import PermissionPicker from '@/components/pickers/PermissionsPicker.vue'
import MemberLocationHours from '@/views/team/MemberLocationHours.vue'
import AppointmentTypesPage from '@/views/space/AppointmentTypesPage.vue'
import AddColleague from '@/components/actions/wizards/InviteMemberWizard/AddColleague.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Manage',
  components: {
    ManageToolbar,
    PermissionPicker,
    MemberLocationHours,
    AppointmentTypesPage,
    AddColleague
  },
  props: {
    page: { type: String, required: false },
    initialSpaceId: { required: false },
    initialPractitionerId: { required: false},
    practitionerSelectable: { type: Boolean, default: true },
    withCrumbs: { type: Boolean, default: true },
    title: { type: String, default: 'Manage' }
  },
  data () {
    return {
      activeTab: 0,
      space: {},
      practitioner: {},
      req: {
        resource: 'ag.spaces',
        extra: '/members'
      },
      addcolleaguedialog: false
    }
  },
  watch: {
    page: {
      immediate: true,
      handler () {
        if (this.page === 'permissions') { this.activeTab = 0 }
        if (this.page === 'hours') { this.activeTab = 1 }
        if (this.page === 'types') { this.activeTab = 2 }
      }
    },
    initialSpaceId: {
      immediate: true,
      handler () {
        this.setSelectedSpaceById(this.initialSpaceId)
      }
    }
  },
  methods: {
    setSelectedSpaceById (id) {
      if (id) {
        let space = this.getSpaceById(this.initialSpaceId)
        if (space) { this.space = space }
      } else { this.space = {} }
    }
  },
  computed: {
    ...mapGetters('identity', ['locationsList']),
    businessId () { return this.computedBusinessId },
    spaceId () { return this.getObjectPath(this.space, 'id') },
    spaceTitle () { return this.getObjectPath(this.space, 'title') },
    practitionerId () { return this.getObjectPath(this.practitioner, 'id') },
    membershipId () { return this.getObjectPath(this.membership, 'id') },
    membership () {
      if (this.spaceId && this.practitionerId) {
        let mem = this.practitioner.memberships.find((mem) => {
          return this.idsAreEqual(mem.service, this.spaceId)
        })
        if (mem && !mem.user) {
          mem.user = {id: this.practitionerId}
        }
        return mem
      }
      return null
    },
    locations () {
      let locs = this.locationsList
      if (this.membership && this.membership.service && locs) {
        console.log(locs)
        locs = locs.filter((loc) => {
          if (loc.spaces) {
            return loc.spaces.indexOf(this.membership.service) > -1
          }
        })
      }
      return locs
    },
    crumbs () {
      let li = [
        { text: 'Home', to: '/' },
        { text: 'Team', to: '/settings/team/' }
      ]
      if (this.spaceId) {
        li.push({
          text: this.space.title,
          to: '/settings/team/' + this.spaceId
        })
      }
      if (this.practitionerId) {
        li.push({
          text: this.practitioner.full_name,
          disabled: true
        })
      }
      return li
    }
  }
}
</script>
